import axios from 'axios';

export const clientGet = async <T>(url: string) => {
    const token = (document.cookie.split('hub$user$payload=')[1] || '').split(';')[0];
    return axios.get<T>(url, {
        headers: {
            Authorization: token ? `Bearer ${token}` : '',
        },
    });
};
